export default {"src":"/_next/static/media/logoutIcon.60f60e22.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};